import styled from 'styled-components';

const LayoutWrapper = styled.div`
  max-width: 1440px;
  margin: 0 auto;
  position: relative;
`;

const Layout = ({ children }) => {
  return <LayoutWrapper>{children}</LayoutWrapper>;
};

export default Layout; 